// extracted by mini-css-extract-plugin
export default {"wrapper":"Datatable_wrapper__pAR52","searchBar":"Datatable_searchBar__Y9dwk"};